import { HashMap } from '../constants';

let nextUid = 1000;

export type NotificationType = 'info' | 'success' | 'error' | 'warning';

/**
 * Object which encapsulates a clientside notification.
 */
export interface Notification {
  /**
   * The unique identifier of the notification.
   */
  uid: number;

  /**
   * The high-level type of the notification.
   */
  type: NotificationType;

  /**
   * The notification category.
   */
  category?: string;

  /**
   * The main title of the notification.
   */
  title: string;

  /**
   * Additional detail about the notification.
   */
  detail?: string;

  /**
   * The date and time on which the notification was raised.
   */
  raisedOn: Date;

  /**
   * A flag indicating whether or not the notification has been read.
   */
  read: boolean;

  /**
   * A flag indicating that the notification has popped up and been hidden.
   */
  hidden: boolean;

  /**
   * Additional notification-specific data.
   */
  additionalData?: HashMap<any>;

  /**
   * An optional action which can be triggered from the notification.
   */
  action?: () => void;

  /**
   * The label to use for the action button.
   */
  actionLabel?: string;
}

/**
 * Gets a new unique identifier to be used with a notification.
 */
export function getNextNotificationUid() {
  return nextUid++;
}
